function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.75 0v17.15l-.228 1.521.915-1.238L50.563 5.307l8.131 8.132-12.126 12.126-1.234.913 1.517-.228H64v11.5H46.85l-1.518-.228 1.236.913 12.126 12.127-8.132 8.132-12.126-12.127-.914-1.236.228 1.52V64h-11.5V46.85l.227-1.515-.91 1.232L13.44 58.694l-8.132-8.132 12.127-12.126 1.236-.914-1.522.228H0v-11.5h17.15l1.518.228-1.235-.913L5.307 13.439l8.132-8.132 12.126 12.126.913 1.236-.228-1.52V0h11.5zm-8.102 26.323l-5.603-7.58L13.44 8.134 8.135 13.44l10.607 10.606 7.58 5.603L17 28.25H2v7.5h15l9.326-1.399-7.582 5.604L8.137 50.562l5.303 5.303L24.047 45.26l5.6-7.578L28.25 47v15h7.5V47l-1.398-9.324 5.604 7.582 10.606 10.607 5.303-5.303L45.26 39.955l-7.581-5.603L47 35.75h15v-7.5H47l-9.32 1.398 7.58-5.603L55.866 13.44l-5.303-5.303-10.607 10.606-5.605 7.583L35.75 17V2h-7.5v15l1.398 9.323z",
  fill: "#fff"
});

function SvgStarOutlinedinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgStarOutlinedinline;